// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as EditManualPenaltyApiModel from "../api-model/EditManualPenaltyApiModel.bs.js";

function apiModelToState(res) {
  return {
          status_code: res.status_code,
          status: res.status
        };
}

function execute(json) {
  return apiModelToState(DeccoUtils$Catalyst.resolveResult(EditManualPenaltyApiModel.t_decode(json), "EditManualPenaltyEntityMapper.res"));
}

export {
  apiModelToState ,
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
